import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../AuthContext/Authcontext";
import Navbar from "../../../Shared/ManagerNavbar/Navbar";
import "./Opportunityview.css";
import baseURL from "../../../Apiurs/Apiurls";

const Opportunityview = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // Get lead ID from URL

  const [formData, setFormData] = useState({
    lead_name: "",
    business_name: "",
    lead_source: "",
    contact_number: "",
    email: "",
    whatsapp_number: "",
    preferred_contact_method: "",
    gstin_lead: "",
    products: [],
  });

  const [leadSources, setLeadSources] = useState([
    "Website",
    "Referral",
    "Cold Call",
    "Email Campaign",
    "Social Media",
  ]);
  const [contactMethods, setContactMethods] = useState(["Phone", "Email", "WhatsApp"]);
  const [loading, setLoading] = useState(false);
  const [loadingLead, setLoadingLead] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [viewMode, setViewMode] = useState(true);
  const [isEdit, setIsEdit] = useState(false);

  // Fetch lead data
  useEffect(() => {
    const fetchLead = async () => {
      setLoadingLead(true);
      try {
        const response = await axios.get(`${baseURL}/api/leads/${id}`);
        console.log("GET /api/leads/:id response:", response.data);
        if (response.data) {
          setFormData(response.data);
          setIsEdit(true);
          setViewMode(true);
        }
      } catch (err) {
        console.error("Error fetching lead:", err.response || err.message);
        setError("Failed to load lead data");
      } finally {
        setLoadingLead(false);
      }
    };

    if (id) fetchLead();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e, action) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const url = `${baseURL}/api/leads/${id}`;
      const response = await axios.put(url, formData);
      console.log("PUT /api/leads/:id response:", response.data);
      setMessage("Lead updated successfully");

      if (action === "saveAndClose") {
        setTimeout(() => navigate(-1), 1000);
      }
    } catch (err) {
      console.error("Error updating lead:", err.response || err.message);
      setError("Failed to update lead");
    } finally {
      setLoading(false);
    }
  };

  const handleEditToggle = () => setViewMode(!viewMode);
  const handleCancel = () => {
    setViewMode(true);
    setError("");
    setMessage("");
  };

  const renderField = (label, name, type = "text", options = null, fullWidth = false, required = false) => {
    const value = formData[name];
    const fieldClass = `Opportunityview-field ${fullWidth ? "full-width" : ""}`;
    const commonProps = { name, className: `Opportunityview-${type === "select" ? "select" : type === "textarea" ? "textarea" : "input"}` };

    if (viewMode) {
      return (
        <div key={name} className={fieldClass}>
          <label className="Opportunityview-label">{label}{required && " *"}</label>
          <span className="Opportunityview-value">{value || "N/A"}</span>
        </div>
      );
    }

    if (type === "select" && options) {
      return (
        <div key={name} className={fieldClass}>
          <label className="Opportunityview-label">{label}{required && " *"}</label>
          <select {...commonProps} value={value} onChange={handleChange} disabled={loading}>
            <option value="">{`Select ${label.toLowerCase()}`}</option>
            {options.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </select>
        </div>
      );
    }

    if (type === "textarea") {
      return (
        <div key={name} className={fieldClass}>
          <label className="Opportunityview-label">{label}</label>
          <textarea {...commonProps} value={value} onChange={handleChange} rows="3" disabled={loading} />
        </div>
      );
    }

    return (
      <div key={name} className={fieldClass}>
        <label className="Opportunityview-label">{label}{required && " *"}</label>
        <input
          {...commonProps}
          type={type}
          value={value}
          onChange={handleChange}
          placeholder={`Enter ${label.toLowerCase()}`}
          maxLength={type === "tel" ? "15" : undefined}
          required={required}
          disabled={loading}
        />
      </div>
    );
  };

  const renderGeneralDetails = () => (
    <div className="Opportunityview-form">
      {renderField("Lead Name / Contact Person", "lead_name", "text", null, false, true)}
      {renderField("Business Name", "business_name", "text")}
      {renderField("Lead Source", "lead_source", "select", leadSources)}
      {renderField("Contact Number", "contact_number", "tel", null, false, true)}
      {renderField("Email Address", "email", "email", null, false, true)}
      {renderField("WhatsApp Number", "whatsapp_number", "tel")}
      {renderField("Preferred Contact Method", "preferred_contact_method", "select", contactMethods)}
      {renderField("GSTIN", "gstin_lead", "text")}
    </div>
  );

  if (loadingLead) {
    return <div className="Opportunityview-loading">Loading lead...</div>;
  }

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="Opportunityview-container">
          <div className="Opportunityview-content">
            {error && <div className="Opportunityview-alert Opportunityview-alert-error">{error}</div>}
            {message && <div className="Opportunityview-alert Opportunityview-alert-success">{message}</div>}

            {viewMode ? (
              <>
                <div className="Opportunityview-header-container">
                  <button className="Opportunityview-btn Opportunityview-btn-secondary" onClick={() => navigate(-1)}>Back</button>
                  <h2 className="Opportunityview-header">View Lead</h2>
                  <button className="Opportunityview-btn Opportunityview-btn-primary" onClick={handleEditToggle}>Edit</button>
                </div>
                {renderGeneralDetails()}
              </>
            ) : (
              <form onSubmit={(e) => handleSubmit(e, "save")} className="Opportunityview-form">
                <div className="Opportunityview-header-container">
                  <button className="Opportunityview-btn Opportunityview-btn-secondary" onClick={() => navigate(-1)}>Back</button>
                  <h2 className="Opportunityview-header">Edit Lead</h2>
                  <div className="Opportunityview-right-buttons">
                    <button className="Opportunityview-btn Opportunityview-btn-secondary" onClick={handleCancel} type="button">Cancel</button>
                    <button className="Opportunityview-btn Opportunityview-btn-primary" type="submit">{loading ? "Updating..." : "Update"}</button>
                  </div>
                </div>
                {renderGeneralDetails()}
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Opportunityview;